/* Swipe-knoppen onder elke rij die horizontaal schuift (15-09).
   Eerdere versie was een pijltje dat aan de rechterrand bleef plakken; dat lag over de
   tekst van de volgende kaart. Nu twee echte knoppen, gecentreerd onder de rij, en ze
   verschijnen alleen als er echt iets te schuiven valt. */
(function () {
  var RIJEN = ['.how-works .hw-steps', '.grid-6:has(.tile)', '[id^="catgrid-"]',
               '.grid-3:has(.review)', '.colcircles .cc-row', '.usp .shell'];
  var PIJL = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" ' +
             'stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';

  function stap(rij) {
    var eerste = rij.querySelector(':scope > *:not(.swipe-nav)');
    if (!eerste) return rij.clientWidth * 0.8;
    var gap = parseFloat(getComputedStyle(rij).columnGap) || 0;
    return eerste.getBoundingClientRect().width + gap;
  }

  function ververs(rij, nav) {
    var kan = rij.scrollWidth - rij.clientWidth > 4;
    nav.hidden = !kan;
    if (!kan) return;
    var links = nav.firstElementChild, rechts = nav.lastElementChild;
    links.disabled = rij.scrollLeft <= 2;
    rechts.disabled = rij.scrollLeft >= rij.scrollWidth - rij.clientWidth - 2;
  }

  function bouw(rij) {
    if (rij.dataset.swipeNav) return;
    rij.dataset.swipeNav = '1';
    var nav = document.createElement('div');
    nav.className = 'swipe-nav';
    nav.innerHTML = '<button type="button" class="arrow swipe-prev" aria-label="Vorige">' + PIJL +
                    '</button><button type="button" class="arrow swipe-next" aria-label="Volgende">' + PIJL + '</button>';
    rij.insertAdjacentElement('afterend', nav);
    function schuif(richting) {
      rij.scrollBy({ left: richting * stap(rij), behavior: 'smooth' });
      /* scroll-events komen tijdens een smooth scroll onregelmatig binnen; daarom ook
         na afloop nog een keer de knoppen bijwerken. */
      setTimeout(function () { ververs(rij, nav); }, 420);
      setTimeout(function () { ververs(rij, nav); }, 900);
    }
    nav.firstElementChild.addEventListener('click', function () { schuif(-1); });
    nav.lastElementChild.addEventListener('click', function () { schuif(1); });
    rij.addEventListener('scroll', function () { ververs(rij, nav); }, { passive: true });
    addEventListener('resize', function () { ververs(rij, nav); });
    ververs(rij, nav);
  }

  function start() {
    RIJEN.forEach(function (sel) {
      var gevonden;
      try { gevonden = document.querySelectorAll(sel); } catch (e) { return; }
      Array.prototype.forEach.call(gevonden, bouw);
    });
  }
  if (document.readyState === 'loading') addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
  addEventListener('load', start);
})();
